export type PostAudience = "public" | "members" | "subscribers" | "plans";
export type PostStatus = "draft" | "published" | "archived";
export type PostMedia = { uuid: string; name: string; mimeType: string; size: number };
export type PortalPost = {
  uuid: string; portalSlug: string; portalName: string; title: string; teaser: string;
  locked: boolean; body: string | null; videoUrl: string | null; cover: PostMedia | null;
  media: PostMedia[]; audience: PostAudience; planUuids: string[]; showTeaser: boolean;
  pinned: boolean; status: PostStatus; publishedAt: string | null; updatedAt: string;
};
export type PostFeed = { items: PortalPost[]; nextOffset: number | null };
export function postMediaUrl(slug: string, uuid: string, postUuid?: string): string {
  const base = `/api/client-portals/${encodeURIComponent(slug)}/post-media/${encodeURIComponent(uuid)}`;
  return postUuid ? `${base}?${new URLSearchParams({ postUuid })}` : base;
}
export async function postRequest<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, { ...init, cache: "no-store" });
  if (!response.ok) throw new Error(String(response.status));
  return response.json() as Promise<T>;
}
export function safePostVideoUrl(value: string | null): string | null {
  if (value && (/^https:\/\/www\.youtube-nocookie\.com\/embed\/[A-Za-z0-9_-]{11}$/.test(value)
    || /^https:\/\/player\.vimeo\.com\/video\/[0-9]+$/.test(value))) return value;
  return null;
}
